export const onSagaError = (/* , errorLocation */) => {
  // Error from saga not wrapped in try catch
};
